import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleDots16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSpeechBubbleDots16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 12v-1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H9.013l-.286.26L6 13.74zm7 0H9.4l-2.727 2.48C6.03 15.062 5 14.607 5 13.74V12H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2M5.25 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M8 8a.75.75 0 1 0 0-1.5A.75.75 0 0 0 8 8m3.5-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeechBubbleDots16);
